import { closePopup, revealPopup } from './custom-popup';

function radioClick(){
  $('.product__details .form-row .radio-holder input').on('change', function() {
    const $this = $(this);
    const radioValue = $this.next('label').text();
    const $selected = $this.parents('form').find('.form-row .option_name .selected');
    const $allRadios = $('.product__details .form-row .radio-holder');
    const $formPopup = $('.form-popup');
    $allRadios.removeClass('active');
    $this.parent().addClass('active');

    $('.option_name.color .selected, .option_name.fabric .selected').each(function() {
      const $ele = $(this);
      const $selectedRadiosHolder = $('.radio-holder input[value="' + $this.val() + '"]').parent();

      $selectedRadiosHolder
        .addClass('active')
        .add($('.radio-holder.clicked'))
        .parents('form')
        .find('.form-row .option_name.color .selected, .form-row .option_name.fabric .selected')
        .attr('data-selected', radioValue)
        .text(radioValue);
      $('.radio-popup .radio-holder input[value="' + $this.val() + '"]').prop('checked', true);
    })

    closePopup('.radio-popup', 300, true)
    if ($this.parent().hasClass('com-col')) {
      revealPopup($formPopup, 100, true);
      $formPopup.find('h2').text(radioValue);
      $formPopup.find('.add-fields.add-material span').text($this.val());
    }
  }).on('click', function() {
    const $this = $(this);
    const $formPopup = $('.form-popup');
    const radioValue = $this.next('label').text();

    closePopup('.radio-popup', 300, true)
    if ($this.parent().hasClass('com-col')) {
      revealPopup($formPopup, 100, true);
      $formPopup.find('h2').text(radioValue);
      $formPopup.find('.add-fields.add-material span').text($this.val());
    }
  })

  $('.product__details .form-row .radio-holder:not(.popup-trigger) input').on('click', function(){
    var index = parseInt($(this).data('slider-index'));
    var hasGroupImg = $('.product__images .slick-list .slick-slide img[alt="group"]').length;
    if(hasGroupImg > 0) {
      index = index + 1;
    }

    $('.product__images .slick-dots li button').each(function(){
      var val = parseInt($(this).text());
      if(val == index) {
        $(this).trigger('click')
      }
    })
  })

  var $selectedColorRadio = $('.radio-holder input[data-checked="true"]');
  if ($selectedColorRadio.length) {
    $selectedColorRadio.each(function() {
      $(this).prop('checked', true).trigger('change')
    })
  }
}

export default radioClick();



// WEBPACK FOOTER //
// ../markup/assets/js/radio-click.js